// @ts-nocheck
import React, { memo, useMemo } from "react";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { styled } from "@mui/system";
import { ReactComponent as ListIcon } from "assets/images/project/application/pipeline.svg";
import { ReactComponent as PipelineIcon } from "assets/images/project/application/list.svg";
import MDDatePicker from "../../../components/MDDatePicker";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

const ViewBox = styled(Box)(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
  paddingLeft: "10px",
  paddingRight: "10px",
  backgroundColor: selected ? "#F0F2F5" : theme.palette.background.paper,
  cursor: "pointer",
  borderRadius: "6px",
  boxShadow: selected ? theme.shadows[3] : "none",
}));

const FilterCheckbox = memo(({ label, checked, onChange }) => (
  <FormControlLabel
    control={<Checkbox checked={checked} onChange={onChange} />}
    label={
      <Typography color={"#344767"} fontSize="0.9rem" fontWeight={"bold"}>
        {label}
      </Typography>
    }
    sx={{ whiteSpace: "nowrap", marginRight: 0, display: "flex", alignItems: "center" }}
  />
));

const TableFilter = memo(
  ({
    view,
    filters,
    onViewChange,
    onFilterChange,
    dateFilters,
    handleDateChange,
    searchQuery,
    onSearchChange,
  }) => {
    const viewOptions = useMemo(
      () => [
        { label: "List", value: "list", icon: <ListIcon />, ariaLabel: "List View" },
        {
          label: "Pipeline",
          value: "pipeline",
          icon: <PipelineIcon />,
          ariaLabel: "Pipeline View",
        },
      ],
      []
    );

    const filterOptions = useMemo(
      () => [
        { label: "Pending", value: "Pending" },
        { label: "Declined", value: "Declined" },
        { label: "Approved", value: "Approved" },
      ],
      []
    );

    return (
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        mb={2}
        style={{ flex: "1", justifyContent: "space-between" }}
      >
        <Box display="flex" alignItems="center" justifyContent={"space-between"}>
          {/* View Selection */}
          <Box display="flex" alignItems="center" gap={2} style={{ marginRight: "18px" }}>
            {viewOptions.map((viewOption) => (
              <ViewBox
                key={viewOption.value}
                selected={view === viewOption.value}
                onClick={() => onViewChange(viewOption.value)}
              >
                {viewOption.icon}
                <Typography ml={1} fontSize="0.875rem">
                  {viewOption.label}
                </Typography>
              </ViewBox>
            ))}
          </Box>
          {/* Status Filters */}
          <Box display="flex" alignItems="center" gap={2} flexWrap="nowrap">
            {filterOptions
              .filter((filter) => {
                if (view?.toLowerCase() === "pipeline") {
                  return filter?.label !== "Approved" && filter?.label !== "Closed";
                }
                return true;
              })
              .map((filter) => (
                <FilterCheckbox
                  key={filter.value}
                  label={filter.label}
                  checked={filters[filter.value]}
                  onChange={() => onFilterChange(filter.value)}
                />
              ))}
          </Box>
        </Box>

        {/*Date Filters*/}
        <Box display="flex" justifyContent="flex-end" alignItems="flex-start" mb={2}>
          <MDDatePicker
            input={{ placeholder: "Filter From Date" }}
            value={dateFilters.fromDate}
            onChange={(date) => handleDateChange("fromDate", date)}
          />
          <Box className={"ml-10"}>
            <MDDatePicker
              input={{ placeholder: "Filter To Date" }}
              value={dateFilters.toDate}
              onChange={(date) => handleDateChange("toDate", date)}
            />
          </Box>

          <MDBox ml="auto">
            <MDInput
              placeholder="Search..."
              value={searchQuery}
              size="small"
              fullWidth
              onChange={({ currentTarget }) => onSearchChange(currentTarget.value)}
              style={{ marginLeft: "10px", minWidth: "100px" }}
            />
          </MDBox>
        </Box>
      </Box>
    );
  }
);

export default TableFilter;
